import React, { ComponentPropsWithRef, PropsWithChildren } from "react";

interface Props extends PropsWithChildren<ComponentPropsWithRef<"tbody">> {
  children?: React.ReactNode;
}

const TableBody = (props: Props) => {
  return (
    <tbody data-testid="table-body" {...props}>
      {props.children}
    </tbody>
  );
};

export default TableBody;
